import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-multiselect-dropdown-v2',
  templateUrl: './multiselect-dropdown-v2.component.html',
  styleUrls: ['./multiselect-dropdown-v2.component.css'],
  providers: [NgbDropdownConfig]
})
export class MultiselectDropdownComponentV2 implements OnInit {
  @Input() catalog:any[];
  @Input() idProps:string[];
  @Input() textProp:string;
  @Input() textProp2:string = null;
  @Input() singleSelect:boolean=false;
  @Input() canSelectAll:boolean;
  @Input() selected:string[]=[];  
  @Input() searchString:string='';
  @Input() returnObjectOrigen:boolean;
  @Input() disabled:number=0;
  @Output() selectedEmitter=new EventEmitter<string[]>();

  @ViewChild("myInput", {static: false}) myInput : ElementRef;

  public closed:boolean=true;
  
  constructor(config:NgbDropdownConfig) {
    config.placement='bottom-left';
    config.autoClose=false;
  }

  ngOnInit() {}

  label=()=> this.selected.length === 0 ? 'Seleccione' : this.selected.map(it=> it[this.textProp]).join(', ');
  
  text = (item) => {
    if (this.textProp2 !== null) {
      return item[this.textProp] + " <<" + item[this.textProp2] + ">>";
    } else {
      return item[this.textProp];
    }
  };

  searchByProps(item1, item2, prop) {
    item1[prop]==item2[prop]
  }
  
  isSelected = (item) => this.selected.find(it => this.idProps.every(prop => it[prop] == item[prop])) !== undefined;
  
  select=(e, item)=> {
    if(e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if(this.singleSelect){
      this.selected=[];
      this.selected.push(item);
      this.showSelected();
    }else{
      if(this.isSelected(item)) {
        this.selected = this.selected.filter(selectedItem => 
          !this.idProps.every(prop => selectedItem[prop] === item[prop])
        );
      } else {
        this.selected.push(item);
      }
    }
  }
  
  selectAll=e=> {
    if(e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.searchString='';
    this.selected=[];
    this.catalog.forEach((item)=>{
      this.selected.push(item);
    });
    //this.selected=this.catalog.map(it=> it[this.idProp]);
    //console.log(">> this.selected=", this.selected);
  }
  
  selectNone=e=> {
    if(e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.searchString='';
    this.selected=[];
  }
  
  showSelected=()=> {
    this.searchString='';
    this.closed=!this.closed;
    if(this.closed) {
      this.selectedEmitter.emit(this.selected);
    }
    this.myInput.nativeElement.focus();
  }
}
